import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { forkJoin } from 'rxjs';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-account-multi-list',
  templateUrl: './../../../templates/forms/modals/account-multi-list.component.html',
})
export class AccountMultiListComponent implements OnInit {
  @Input()
  config: any;
  
  @Input()
  modalShow: boolean = true;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  chartOfAccountList:any[] = [];
  columnDefs = [];
  colObj;
  grid:any;
  gridId:string = "AccountMultiListGrid";
  constructor(private dataService: CommonService,
    public langService: LangService, public gridService: GridService) { 
      this.colObj = [
        { headerName: 'Account Name', filter: 'agTextColumnFilter', field: 'ACC_NAME', sortable: true, resizable: true, hide: false },
        { headerName: 'Acc Path', field: 'ACC_PATH', sortable: true, filter: true, resizable: true, hide: false },
        { headerName: 'Map Account', field: 'MAP_ACC_NAME', sortable: true, filter: true, resizable: true, hide: false }
      ];
     }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    // setTimeout(()=> {
    //   document.getElementById('searchString').focus();
    // });
    
    
  }

  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.getChartOfAccounts(fixedValues.queryOptions.CoaForAV)
    .subscribe(arg => {this.chartOfAccountList = arg.body});
  }

  itemClick(_item) {    
    this.modalShow=false;
    this.dataObj=_item;
    forkJoin(
      this.dataService.getBusinessAreas(fixedValues.queryOptions.BusinessAreaForAV, _item.ACC_NO),
      this.dataService.getReferences(_item.ACC_NO)
      ).subscribe(results => {
      this.dataObj['businessAreaList'] = results[0]['body'];
      this.dataObj['referenceList'] = results[1]['body'];
      this.submit.next();
    }, error => {
      this.dataObj['businessAreaList'] = [];
      this.dataObj['referenceList'] = [];
      this.submit.next();
    });
  }

}
